export const styles = (theme: any) => {
    return {
        root: {
            marginRight: '5px'
        },
        voteLabel: {
            marginTop: '20px'
        },
        searchField: {
            paddingRight: '10px'
        }
    }
}